export default "__VITE_ASSET__9cb4f75a__"